import { useEffect } from 'react';

// Imposta il titolo della scheda del browser, ad esempio "Pazienti · Neurotraining".
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · Neurotraining` : 'Neurotraining';
  }, [title]);
}
